import { ScoreType } from '../store/admin/eventFormats/store';
import { TIFormatPrefix } from '../store/admin/roundFormats/store';

import { TTeamFormatPrefix } from '../scenes/admin/EventWizard/Common/AssignResults/Context/AssignResults.context';

const scoreTypeMap = {
  [ScoreType.GROSS]: 'Gross',
  [ScoreType.NET]: 'Net'
};

export const sortResultsWithTiebreak = (
  array: any[],
  selectedScoreType: ScoreType | undefined,
  formatIsStableford: boolean,
  format: TTeamFormatPrefix | TIFormatPrefix = 'stroke',
  customAttribute?: string
) => {
  if (!selectedScoreType) {
    return array;
  }

  const stableFord = formatIsStableford ? 'Stableford' : '';

  const scoreType = scoreTypeMap[selectedScoreType];

  const attribute = customAttribute || `${format}${scoreType}${stableFord}Position`;
  const tiebreakAttribute = `${format}${scoreType}${stableFord}Tiebreak`;

  return array.slice().sort((a: any, b: any) => {
    const aAttribute = a[attribute];
    const bAttribute = b[attribute];
    const aTiebreakAttribute = a[tiebreakAttribute];
    const bTiebreakAttribute = b[tiebreakAttribute];

    if (
      (aAttribute === undefined || aAttribute === null) &&
      (bAttribute === undefined || bAttribute === null)
    ) {
      return 0;
    }

    if (aAttribute > bAttribute || aAttribute === undefined || aAttribute === null) {
      return 1;
    }

    if (aAttribute < bAttribute || bAttribute === undefined || bAttribute === null) {
      return -1;
    }

    if (a.through > b.through) {
      return -1;
    }

    if (a.through < b.through) {
      return 1;
    }

    if (aTiebreakAttribute > bTiebreakAttribute) {
      return 1;
    }

    if (aTiebreakAttribute < bTiebreakAttribute) {
      return -1;
    }

    return 0;
  });
};
